import "../stylesheets/style";

// 検索トップ
$(function () {
  $(".js-nav-location-pap").on("click", function () {
    const url = "https://www.yayoi-kk.co.jp/pap/";
    window.open(url, "_blank");
  });
});
